import React from 'react';
import {Link} from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import SearchIcon from '@material-ui/icons/Search';
import {adminRoutes} from 'App/AppRouter/routes';
import './ContentPartnersToolbar.scss';

interface ContentPartnersToolbarProps {
    handleNameChange: () => void;
    name: string;
}

export default function ContentPartnersToolbar(props: ContentPartnersToolbarProps) {
    const {handleNameChange, name} = props;
    const url = String(adminRoutes.newContentPartner);
    const searchAdornment = (
        <InputAdornment position="start">
            <SearchIcon />
        </InputAdornment>
    );

    return (
        <Box className="toolbar">
            <Box className="toolbar-actions">
                <FormControl className="toolbar-actions__input-container">
                    <Input
                        id="content-partner-name"
                        autoComplete="off"
                        value={name}
                        placeholder="PARTNER NAME OR ID"
                        onChange={handleNameChange}
                        startAdornment={searchAdornment}
                    />
                </FormControl>
            </Box>
            <Link className="toolbar__button-link" to={url}>
                <Button className="toolbar__button" variant="contained">
                    ADD CONTENT PARTNER
                </Button>
            </Link>
        </Box>
    );
}
